<template>
  <div>
    <section class="content-header" style="height: 50px; padding-bottom: 80px;">
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
      <span v-if="$root.device.isMobile" style="display:block; font-weight: bold; ">
        <br />
        {{selectedVersion ? $root.shortText(selectedVersion.Name, 40) : ''}}
        <br />
      </span>
      <h1 v-else style="float: left; word-wrap:break-word; padding-right: 10px; background-color: #ddd;">{{selectedVersion ? $root.shortText(selectedVersion.Name, 26) : ''}}</h1>
      <div style="float: right; padding: 0px 10px;">
        <ul class="pagination pagination-sm inline" style="cursor: pointer;">
          <li v-if="$root.isAdmin">
            <a style="width: 120px!important; text-align: center;">
              <label @click="updateWebVersion" action="#" method="get" style="margin: 0px; border: none;">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: green">
                  <!--<i class="fa fa-upload btnUpload"></i>-->
                  <span class="btnUpload">Update Web Version</span>
                </div>
              </label>
            </a>
          </li>
          <li v-if="$root.isAdmin" v-show="!showProgress">
            <a style="width: 150px!important; text-align: center;">
              <label action="#" method="get" style="margin: 0px; border: none;">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: red">
                  <!--<i class="fa fa-upload btnUpload"></i>-->
                  <span class="btnUpload">Upload Updates (for LAN Printers)</span>
                  <input type="file" @change="uploadUpdateLAN" />
                </div>
              </label>
            </a>
          </li>
          <li v-if="$root.isAdmin" v-show="!showProgress">
            <a style="width: 150px!important; text-align: center;">
              <label action="#" method="get" style="margin: 0px; border: none;">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: red">
                  <!--<i class="fa fa-upload btnUpload"></i>-->
                  <span class="btnUpload">Upload Updates (for USB Printers)</span>
                  <input type="file" @change="uploadUpdateUSB" />
                </div>
              </label>
            </a>
          </li>
          <li v-if="$root.isAdmin" v-show="!showProgress">
            <a style="width: 150px!important; text-align: center;">
              <label action="#" method="get" style="margin: 0px; border: none;">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: red">
                  <!--<i class="fa fa-upload btnUpload"></i>-->
                  <span class="btnUpload">Upload Installer (for LAN Printers)</span>
                  <input type="file" @change="uploadInstallerLAN" />
                </div>
              </label>
            </a>
          </li>
          <li v-if="$root.isAdmin" v-show="!showProgress">
            <a style="width: 150px!important; text-align: center;">
              <label action="#" method="get" style="margin: 0px; border: none;">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: red">
                  <!--<i class="fa fa-upload btnUpload"></i>-->
                  <span class="btnUpload">Upload Installer (for USB Printers)</span>
                  <input type="file" @change="uploadInstallerUSB" />
                </div>
              </label>
            </a>
          </li>
          <li v-else>
            <a style="width: 150px!important; text-align: center;" v-if="0>1">
              <label title="Download [Printer Counters] installer latest version" action="#" method="get" style="margin: 0px; border: none;" @click="downloadClientLAN()">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: green;">
                  <!--<i class="fa fa-download btnUpload"></i>-->
                  <span class="btnUpload">Download LAN Client Installer</span>
                </div>
              </label>
            </a>
            <a style="width: 150px!important; text-align: center;" v-if="0>1">
              <label title="Download [Printer Counters] installer latest version" action="#" method="get" style="margin: 0px; border: none;" @click="downloadClientUSB()">
                <div class="input-group btnUpload" style="padding: 5px 10px; color: green;">
                  <!--<i class="fa fa-download btnUpload"></i>-->
                  <span class="btnUpload">Download USB Client Installer</span>
                </div>
              </label>
            </a>
          </li>
          <li v-if="$root.isAdmin" v-show="showProgress">
            <a style="width: 80px!important; text-align: center;">
              <div class="progress-group" style="float: right; margin: 0px; width: 170px;">
                <span class="progress-text">Uploading ...</span>
                <div class="progress sm">
                  <div class="progress-bar progress-bar-success" :style="{ width: percent + '%' }"></div>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </section>
    <div class="box-body">
      <row>
        <column class="col-md-6">
          <column class="col-md-12">
            <va-box title="Customers and Sites" :isBorder="true" theme="box-warning" widgetType="" :list="dealers" ref="dealersBox" @change="dealerChanged">
              <div slot="content">
                <div class="table-responsive">
                  <h5>Please select Site(s) to be updated:</h5>
                  <va-alert v-if="!hasData && 0 > 1" type="warning" style="width: 100%;">
                    <div slot="header">
                      <i class="icon fa fa-warning"></i> No Data Found !
                    </div>
                  </va-alert>
                  <!--<tree ref="treeSites" :data="treeSites" :options="{ checkbox: true }" @node:checked="siteChecked" @node:unchecked="siteUnchecked" />-->
                  <tree class="tree--small" :key="selectedDealer" if="!isLoadingTree" ref="treeSites" :data="treeSites" :options="{ checkbox: true }" @node:checked="siteChecked" @node:unchecked="siteUnchecked">
                    <span class="tree-text" slot-scope="{ node }">
                      <template>
                        <i v-if="node.data && node.data.isDealer" class="ion-bag"></i>
                        <i v-if="node.data && node.data.isCustomer" class="icon fa fa-user-o"></i>
                        <!--<i v-if="node.data && node.data.isComputer" class="icon fa fa-laptop"></i>-->
                        <!--<img v-if="node.data && node.data.isComputer && node.data.isUSB" src="../../static/img/USB icon.png" alt="USB Client" title="USB Client" style="width: 20px; height: 20px;" />
                        <img v-if="node.data && node.data.isComputer && !node.data.isUSB" src="../../static/img/LAN icon.png" alt="Network Client" title="Network Client" style="width: 18px; height: 18px;" />-->
                        <i v-if="node.data && node.data.isComputer && node.data.isUSB" class="icon fa fa-usb" title="USB Client"></i>
                        <i v-if="node.data && node.data.isComputer && !node.data.isUSB" class="icon fa fa-sitemap" title="Network Client"></i>
                        {{ node.text }}
                        <small v-if="node.data && node.data.isComputer" class="label label-default">{{ node.data.currentVersion }}</small>
                        <small v-if="node.data && node.data.isComputer" class="label label-default">{{ node.data.siteKey }}</small>
                      </template>
                    </span>
                  </tree>
                </div>
              </div>
            </va-box>
          </column>
        </column>
        <column class="col-md-6">
          <column class="col-md-12">
            <va-box title="Latest Versions (for LAN Printers)" :isBorder="true" theme="box-warning" widgetType="">
              <div slot="content">
                <h5>Please select LAN client version to be downloaded:</h5>
                <ul>
                  <li v-for="(ver, index) in versionsList" v-if="!ver.IsUSB" @click="selectVersion(ver['.key'])" :class="['tree-node', ver.selected?'checked':'']">
                    <div class="tree-content tree--small">
                      <i :class="['tree-checkbox', ver.selected?'checked':'']"></i>
                      <span tabindex="-1" class="tree-anchor">
                        <span class="tree-text" style="white-space: normal;">
                          <i v-if="!$root.device.isMobile" class="icon fa fa-windows"></i> {{$root.shortText(ver.Name, 40)}}
                          <small v-if="!$root.device.isMobile" class="label label-default"><i class="fa fa-clock-o"></i> {{ver.Date}}</small>
                          <small v-if="!$root.device.isMobile" class="label label-default"> {{ver['.key']}}</small>
                        </span>
                      </span>
                      <div class="tools" v-if="$root.isAdmin && !$root.device.isMobile">
                        <i class="fa fa-trash-o" @click="confirmDelete(ver)"></i>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div slot="footer">
                <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
                <va-button :isBlock="false" theme="success" name="Update" align="right" @click.native="updateLAN" style="margin-right: 10px;"></va-button>
              </div>
            </va-box>
          </column>
          <column class="col-md-12">
            <va-box title="Latest Versions (for USB Printers)" :isBorder="true" theme="box-warning" widgetType="">
              <div slot="content">
                <h5>Please select USB client version to be downloaded:</h5>
                <ul>
                  <li v-for="(ver, index) in versionsList" v-if="ver.IsUSB" @click="selectVersion(ver['.key'])" :class="['tree-node', ver.selected?'checked':'']">
                    <div class="tree-content tree--small">
                      <i :class="['tree-checkbox', ver.selected?'checked':'']"></i>
                      <span tabindex="-1" class="tree-anchor">
                        <span class="tree-text" style="white-space: normal;">
                          <i v-if="!$root.device.isMobile" class="icon fa fa-windows"></i> {{$root.shortText(ver.Name, 40)}}
                          <small v-if="!$root.device.isMobile" class="label label-default"><i class="fa fa-clock-o"></i> {{ver.Date}}</small>
                          <small v-if="!$root.device.isMobile" class="label label-default"> {{ver['.key']}}</small>
                        </span>
                      </span>
                      <div class="tools" v-if="$root.isAdmin && !$root.device.isMobile">
                        <i class="fa fa-trash-o" @click="confirmDelete(ver)"></i>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div slot="footer">
                <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
                <va-button :isBlock="false" theme="success" name="Update" align="right" @click.native="updateUSB" style="margin-right: 10px;"></va-button>
              </div>
            </va-box>
          </column>
        </column>
      </row>
    </div>
    <va-modal></va-modal>
  </div>
</template>
<script>
  import VABox from '../widgets/VABox'
  import VACheckList from '../widgets/VACheckList.vue'
  import VACheckBox from '../components/VACheckBox'
  import VAButton from '../components/VAButton'
  import AddSite from '../components/AddSite'
  import VASelect from '../components/VASelect'
  import Modal from '../components/Modal'
  import VAAlert from '../components/VAAlert.vue'
  import { db, timestamp, storage, dbListener } from '../firebase'
  export default {
    name: 'updates',
    components: {
      'va-box': VABox,
      VACheckList,
      'va-button': VAButton,
      'va-alert': VAAlert,
      AddSite,
      'va-checkbox': VACheckBox,
      'va-select': VASelect,
      'va-modal': Modal
    },
    data () {
      return {
        readyFileName: '',
        percent: 0,
        showProgress: false,
        fileUrl: '',
        selectedVersion: null,
        treeSites: [],
        treeSitesOptions: {
          checkbox: true,
          checkOnSelect: true
        },
        updateSites: [],
        selectedDealer: '',
        isLoadingTree: false,
        sortedDealers: []
      }
    },
    firebase: {
      versionsList: {
        source: db.ref('ClientVersions').orderByChild('TimeStamp'),
        // optionally bind as an object
        asObject: false,
        // optionally provide the cancelCallback
        cancelCallback: function () { },
        // this is called once the data has been retrieved from firebase
        readyCallback: function () {
          this.selectVersion(null)
        }
      }
    },
    watch: {
      versionsCount (val) {
        if (val && val > 0) {
          this.versionsList[0].selected = true
          this.selectedVersion = this.versionsList[0]
        }
      }
    },
    created () {
      console.log('Updates created...')
      this.$root.title = 'Updates'
      try {
        this.reloadSites()
      } catch (e) {
        console.log(e)
      }
    },
    mounted () {
      console.log('Updates mounted...')
      let vm = this
      vm.sortedDealers = vm.dealers.sort(vm.compareItems)
    },
    updated () {
      console.log('Updates updated...')
      // let vm = this
      // vm.sortedDealers = vm.dealers.sort(vm.compareItems)
    },
    computed: {
      dealers () {
        // let vm = this
        // vm.dealers = vm.dealers.sort(vm.compareItems)
        /*
        var dealersArr = []
        if (this.$root.isAdmin) {
          dealersArr.push({ isSelected: false, title: 'All', value: 'All' })
          dealersArr = dealersArr.concat(vm.sortedDealers)
          return dealersArr
        } else {
          return vm.sortedDealers
        }
        */
        /*
        var dealersArr = []
        if (this.$root.isAdmin) {
          dealersArr.push({ isSelected: false, title: 'All', value: 'All' })
        }
        dealersArr = dealersArr.concat(this.$root.dealers)
        return dealersArr
        */
        if (this.$root.isAdmin) {
          return this.$root.dealers
        } else {
          return null
        }
      },
      versionsCount () {
        if (this.versionsList && this.versionsList.length > 0) {
          return this.versionsList.length
        } else {
          return 0
        }
      },
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.treeSites.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.treeSites
        }
        return result
      }
    },
    methods: {
      compareItems (a, b) {
        try {
          const nameA = a.title.toUpperCase()
          const nameB = b.title.toUpperCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        } catch (e) {
          return 0
        }
      },
      updateWebVersion () {
        const vm = this
        db.ref('Dashboard/Admin/Version').set(vm.$root.version)
        console.log(vm.$root.version)
        console.log(Number(vm.$root.version))
        vm.$root.showAlert('Web Version', 'Web Version was updated successfuly.')
      },
      dealerChanged (value) {
        console.log('dealerChanged started...')
        console.log(value)
        this.selectedDealer = value
        this.reloadSites()
      },
      downloadClientLAN () {
        console.log('downloadClient started...')
        db.ref('Settings/ClientInstaller').once('value', (snapInstaller) => {
          const installer = snapInstaller.val()
          if (installer) {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = installer.DownloadUrl
            // hiddenElement.target = '_blank'
            hiddenElement.download = installer.Name
            // hiddenElement.download = installer.Name.replace('.msi', '@ccccs.msi')
            alert(hiddenElement.download)
            hiddenElement.click()
          }
        })
      },
      downloadClientUSB () {
        console.log('downloadClientUSB started...')
        db.ref('Settings/ClientInstallerUSB').once('value', (snapInstaller) => {
          const installer = snapInstaller.val()
          if (installer) {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = installer.DownloadUrl
            // hiddenElement.target = '_blank'
            hiddenElement.download = installer.Name
            hiddenElement.click()
          }
        })
      },
      showError (title, error) {
        this.$bus.$emit('modal-open', {
          title: title,
          description: error,
          type: 'modal-primary',
          cancelText: 'Close',
          confirmBefore: () => {
          },
          confirmAfter: () => {
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      updateLAN () {
        console.log('updateLAN client..')
        // console.log(this.selectedVersion)
        if (this.selectedVersion && this.selectedVersion['.key']) {
          console.log(this.selectedVersion.IsUSB)
          if (!this.selectedVersion.IsUSB) {
            if (this.updateSites && this.updateSites.length > 0) {
              for (let i = 0; i < this.updateSites.length; i++) {
                if (!this.updateSites[i].isUSB) {
                  // console.log('UpdateClient/' + this.updateSites[i].siteKey)
                  // dbListener.ref('UpdateClient/' + this.updateSites[i].siteKey + '/VersionKey').set(this.updateSites[i].versionKey)
                  dbListener.ref('UpdateClient/' + this.updateSites[i].siteKey + '/VersionKey').set(this.selectedVersion['.key'])
                }
              }
              // this.showError('Update Version', 'Update client version started ...')
              this.$notify({
                type: 'success',
                title: 'Update Version',
                text: 'Update client version started ... (USB client will be ignored!)'
              })
            } else {
              this.showError('Error', 'Please select Site(s) to be updated!')
            }
          } else {
            this.showError('Error', 'Please select LAN version to be updated!')
          }
        } else {
          this.showError('Error', 'Please select [Client Version]')
        }
      },
      updateUSB () {
        console.log('updateUSB client..')
        console.log(this.selectedVersion)
        console.log(this.updateSites)
        if (this.selectedVersion && this.selectedVersion['.key']) {
          if (this.selectedVersion.IsUSB) {
            if (this.updateSites && this.updateSites.length > 0) {
              for (let i = 0; i < this.updateSites.length; i++) {
                if (this.updateSites[i].isUSB) {
                  console.log('UpdateClient/' + this.updateSites[i].siteKey)
                  console.log({ 'VersionKey': this.updateSites[i].versionKey })
                  console.log({ 'UsbVersionKey': this.updateSites[i].versionKey })
                  // dbListener.ref('UpdateClient/' + this.updateSites[i].siteKey + '/UsbVersionKey').set(this.updateSites[i].versionKey)
                  dbListener.ref('UpdateClient/' + this.updateSites[i].siteKey + '/UsbVersionKey').set(this.selectedVersion['.key'])
                } else {
                  console.log('This site ' + this.updateSites[i].siteKey + ' is not USB')
                }
              }
              // this.showError('Update Version', 'Update client version started ...')
              this.$notify({
                type: 'success',
                title: 'Update Version',
                text: 'Update client version started ... (LAN client will be ignored!)'
              })
            } else {
              this.showError('Error', 'Please select Site(s) to be updated!')
            }
          } else {
            this.showError('Error', 'Please select USB version to be updated!')
          }
        } else {
          this.showError('Error', 'Please select [Client Version]')
        }
      },
      cancel () {
        this.updateSites = []
        let selection = this.$refs.treeSites.findAll({ data: { isDealer: true } })
        selection.uncheck()
      },
      uploadInstallerLAN (e) {
        var vm = this
        vm.readyFileName = ''
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) return

        var file = files[0]
        vm.showProgress = true
        var storagePath = 'PrinterCountersInstaller/' + file.name
        var storageRef = storage.ref(storagePath)
        var task = storageRef.put(file)
        task.on('state_changed',
          function progress (snap) {
            vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100
            console.log(vm.percent)
          },
          function error (err) {
            vm.showProgress = false
            console.log(err)
          },
          function complete () {
            vm.showProgress = false
            vm.percent = 0
            storage.ref(storagePath).getDownloadURL().then(function (downloadURL) {
              console.log(downloadURL)
              // let timestamp = db.ServerValue.TIMESTAMP
              console.log(timestamp)
              let newVersion = {
                Name: file.name,
                DownloadUrl: downloadURL,
                Date: vm.$moment().format('YYYY-MM-DD HH:mm'),
                TimeStamp: timestamp,
                IsUSB: false
              }
              console.log(JSON.stringify(newVersion))
              db.ref('Settings/ClientInstaller').set(newVersion)
            })
          }
        )
      },
      uploadInstallerUSB (e) {
        var vm = this
        vm.readyFileName = ''
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) return

        var file = files[0]
        vm.showProgress = true
        var storagePath = 'PrinterCountersInstaller/' + file.name
        var storageRef = storage.ref(storagePath)
        var task = storageRef.put(file)
        task.on('state_changed',
          function progress (snap) {
            vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100
            console.log(vm.percent)
          },
          function error (err) {
            vm.showProgress = false
            console.log(err)
          },
          function complete () {
            vm.showProgress = false
            vm.percent = 0
            storage.ref(storagePath).getDownloadURL().then(function (downloadURL) {
              console.log(downloadURL)
              // let timestamp = db.ServerValue.TIMESTAMP
              console.log(timestamp)
              let newVersion = {
                Name: file.name,
                DownloadUrl: downloadURL,
                Date: vm.$moment().format('YYYY-MM-DD HH:mm'),
                TimeStamp: timestamp,
                IsUSB: true
              }
              console.log(JSON.stringify(newVersion))
              db.ref('Settings/ClientInstallerUSB').set(newVersion)
            })
          }
        )
      },
      uploadUpdateLAN (e) {
        var vm = this
        vm.readyFileName = ''
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) return

        var file = files[0]
        vm.showProgress = true
        var storagePath = 'PrinterCounterVersion/' + file.name
        var storageRef = storage.ref(storagePath)
        var task = storageRef.put(file)

        task.on('state_changed',
          function progress (snap) {
            vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100
            console.log(vm.percent)
          },
          function error (err) {
            vm.showProgress = false
            console.log(err)
          },
          function complete () {
            vm.showProgress = false
            vm.percent = 0
            storage.ref(storagePath).getDownloadURL().then(function (downloadURL) {
              console.log(downloadURL)
              // let timestamp = db.ServerValue.TIMESTAMP
              console.log(timestamp)
              let newVersion = {
                Name: file.name,
                DownloadUrl: downloadURL,
                Date: vm.$moment().format('YYYY-MM-DD HH:mm'),
                TimeStamp: timestamp,
                IsUSB: false
              }
              console.log(JSON.stringify(newVersion))
              const promise = db.ref('ClientVersions').push(newVersion)
              const key = promise.key
              promise.then(_ => {
                const verRef = db.ref('ClientVersions/' + key + '/TimeStamp')
                verRef.once('value').then(function (snapTimeStamp) {
                  verRef.set(Number(snapTimeStamp.val()) * -1)
                })
              })
            })
          }
        )
      },
      uploadUpdateUSB (e) {
        var vm = this
        vm.readyFileName = ''
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) return

        var file = files[0]
        vm.showProgress = true
        var storagePath = 'PrinterCounterVersionUSB/' + file.name
        var storageRef = storage.ref(storagePath)
        var task = storageRef.put(file)

        task.on('state_changed',
          function progress (snap) {
            vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100
            console.log(vm.percent)
          },
          function error (err) {
            vm.showProgress = false
            console.log(err)
          },
          function complete () {
            vm.showProgress = false
            vm.percent = 0
            storage.ref(storagePath).getDownloadURL().then(function (downloadURL) {
              console.log(downloadURL)
              // let timestamp = db.ServerValue.TIMESTAMP
              console.log(timestamp)
              let newVersion = {
                Name: file.name,
                DownloadUrl: downloadURL,
                Date: vm.$moment().format('YYYY-MM-DD HH:mm'),
                TimeStamp: timestamp,
                IsUSB: true
              }
              console.log(JSON.stringify(newVersion))
              const promise = db.ref('ClientVersions').push(newVersion)
              const key = promise.key
              promise.then(_ => {
                const verRef = db.ref('ClientVersions/' + key + '/TimeStamp')
                verRef.once('value').then(function (snapTimeStamp) {
                  verRef.set(Number(snapTimeStamp.val()) * -1)
                })
              })
            })
          }
        )
      },
      siteChecked (node) {
        console.log('siteChecked...')
        let disabled = node.disabled()
        if (!disabled) {
          if (node.data.siteKey) {
            console.log(node)
            console.log(node.text)
            console.log(node.data.siteKey)

            let isUSB = node.data.isUSB
            // 'UpdateClient/' + node.data.siteKey
            this.updateSites.push({ siteKey: node.data.siteKey, versionKey: this.selectedVersion['.key'], isUSB: isUSB })
            // db.ref('UpdateClient/' + node.data.siteKey).set(this.selectedVersion)
          } else {
            console.log('No Site Key !!')
            // alert('No Site Key !!')
          }
        } else {
          console.log('Node Disabled !!')
          node.uncheck()
          // console.log(node.disabled())
          // console.log(node.checked())
        }
      },
      siteUnchecked (node) {
        console.log('siteUnchecked...')
        if (node.data.siteKey) {
          console.log(node)
          console.log(node.text)
          console.log(node.data.siteKey)
          for (let i = 0; i < this.updateSites.length; i++) {
            if (this.updateSites[i].siteKey === node.data.siteKey) {
              this.updateSites.splice(i, 1)
              break
            }
          }
        } else {
          console.log('No Site Key !!')
        }
      },
      selectVersion (verKey) {
        console.log('selectVersion(' + verKey + ') ...')
        if (this.versionsList.length > 0) {
          for (let i = 0; i < this.versionsList.length; i++) {
            this.versionsList[i].selected = false
          }
        }
        if (verKey) {
          for (let i = 0; i < this.versionsList.length; i++) {
            this.versionsList[i].selected = (this.versionsList[i]['.key'] === verKey)
            if (this.versionsList[i].selected) {
              this.selectedVersion = this.versionsList[i]
            }
          }
        } else {
          if (this.versionsList.length > 0) {
            this.selectVersion(this.versionsList[0]['.key'])
          } else {
            this.selectedVersion = null
          }
        }
      },
      reloadSites () {
        console.log('reloadSites...')
        const vm = this
        if (vm.$root.isAdmin) {
          vm.loadAdminSitesTree()
        } else {
          vm.loadSitesTree()
        }
        // vm.loadSitesTree()
      },
      loadAdminSitesTree () {
        console.log('loadAdminSitesTree...')
        const vm = this
        vm.treeSites = []
        let dealerName = ''
        if (vm.selectedDealer) {
          if (vm.selectedDealer === 'All') {
            dealerName = vm.selectedDealer
          } else {
            for (let d = 0; d < vm.$root.dealers.length; d++) {
              if (vm.$root.dealers[d].value === vm.selectedDealer) {
                dealerName = vm.$root.dealers[d].title
                break
              }
            }
          }
        } else {
          vm.selectedDealer = vm.$root.dealers[0]
          dealerName = vm.$root.dealers[0].title
        }
        console.log('loadAdminSitesTree... ' + vm.selectedDealer)
        let nodeDealer = {
          text: dealerName,
          state: { expanded: true, disabled: false },
          data: { isDealer: true },
          children: []
        }
        for (let i = 0; i < vm.$root.slideItems.length; i++) {
          if (vm.$root.slideItems[i].type === 'tree') {
            console.log(((vm.selectedDealer === 'All') || (vm.$root.slideItems[i].key === vm.selectedDealer)))
            if ((vm.selectedDealer === 'All') || (vm.$root.slideItems[i].key === vm.selectedDealer)) {
              if (vm.$root.slideItems[i].items && vm.$root.slideItems[i].items.length > 0) {
                for (let j = 0; j < vm.$root.slideItems[i].items.length; j++) {
                  let customerNode = {
                    text: vm.$root.slideItems[i].items[j].FullName,
                    // key: vm.$root.slideItems[i].key,
                    data: { isCustomer: true },
                    state: { expanded: false, disabled: false },
                    children: []
                  }
                  if (vm.$root.slideItems[i].items[j].subItems && vm.$root.slideItems[i].items[j].subItems.length > 0) {
                    for (let s = 0; s < vm.$root.slideItems[i].items[j].subItems.length; s++) {
                      if (vm.$root.slideItems[i].items[j].subItems[s].computer) {
                        let isExist = false
                        for (let c = 0; c < customerNode.children.length; c++) {
                          if (customerNode.children[c].text === vm.$root.slideItems[i].items[j].subItems[s].computer) {
                            isExist = true
                            break
                          }
                        }
                        if (!isExist) {
                          // let title = vm.$root.slideItems[i].items[j].subItems[s].computer
                          // title += vm.$root.slideItems[i].items[j].subItems[s].isUSB ? ' (USB ver.)' : ' (LAN ver.)'
                          let isUSB = vm.$root.slideItems[i].items[j].subItems[s].isUSB
                          let siteNode = {
                            text: vm.$root.slideItems[i].items[j].subItems[s].computer,
                            key: vm.$root.slideItems[i].items[j].subItems[s].key,
                            data: { isComputer: true, isUSB: isUSB, siteKey: vm.$root.slideItems[i].items[j].subItems[s].key, currentVersion: vm.$root.slideItems[i].items[j].subItems[s].version },
                            state: { expanded: true }
                          }
                          customerNode.children.push(siteNode)
                        }
                      }
                    }
                    customerNode.state.disabled = (customerNode.children.length === 0)
                    // customerNode.state.disabled = false
                  } else {
                    customerNode.state.disabled = true
                    // customerNode.state.disabled = false
                  }
                  nodeDealer.children.push(customerNode)
                }
              } else {
                nodeDealer.state.disabled = true
              }
              vm.treeSites.push(nodeDealer)
              break
            }
          }
        }
      },
      loadSitesTree () {
        console.log('loadSitesTree...')
        const vm = this
        vm.treeSites = []

        let dealerName = ''
        dealerName = vm.$root.userFullName

        let nodeDealer = {
          text: dealerName,
          state: { expanded: true },
          data: { isDealer: true },
          children: []
        }
        vm.treeSites.push(nodeDealer)

        for (let i = 0; i < vm.$root.slideItems.length; i++) {
          if (vm.$root.slideItems[i].type === 'tree') {
            let node = {
              text: vm.$root.slideItems[i].FullName,
              key: vm.$root.slideItems[i].key,
              data: { isCustomer: true },
              state: { expanded: false, disabled: false }
            }

            console.log(node)

            if (vm.$root.slideItems[i].items && vm.$root.slideItems[i].items.length > 0) {
              node.children = []
              for (let j = 0; j < vm.$root.slideItems[i].items.length; j++) {
                if (vm.$root.slideItems[i].items[j].computer) {
                  let isExist = false
                  // let version = vm.$root.slideItems[i].items[j].version ? ' [' + vm.$root.slideItems[i].items[j].version + ']' : ''
                  for (let c = 0; c < node.children.length; c++) {
                    if (node.children[c].text === vm.$root.slideItems[i].items[j].computer) {
                      isExist = true
                      break
                    }
                  }
                  if (!isExist) {
                    let isUSB = vm.$root.slideItems[i].items[j].isUSB
                    node.children.push({
                      // text: '[Site] ' + vm.$root.slideItems[i].items[j].Name + ' [' + vm.$root.slideItems[i].items[j].version + ']',
                      // text: vm.$root.slideItems[i].items[j].Name + version,
                      text: vm.$root.slideItems[i].items[j].computer,
                      key: vm.$root.slideItems[i].items[j].key,
                      data: { isComputer: true, isUSB: isUSB, siteKey: vm.$root.slideItems[i].items[j].key, currentVersion: vm.$root.slideItems[i].items[j].version },
                      state: { expanded: true }
                    })
                  }
                }
              }
            }
            node.state.disabled = (!node.children || node.children.length === 0)
            vm.treeSites[0].children.push(node)
          }
        }
        vm.$forceUpdate()
      },
      confirmDelete (ver) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Delete User',
          description: 'Are you sure you want to delete Version [' + ver.text + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            db.ref('ClientVersions/' + ver['.key']).remove()
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }
    }
  }
</script>

<style>
  .btnUpload{
    cursor: pointer;
  }
    .btnUpload > input[type=file] {
      display: none;
    }
</style>




// WEBPACK FOOTER //
// Updates.vue?24ca669f